import PropTypes from 'prop-types';
import React from 'react';
import { useSession } from '@hooks';

type AccomodationsAreaProps = {
  //
};

const languagesVarsCodes = [
  "LANG_neobooking_my_accomodations", //Mon/mes hébergement(s)
]

const AccomodationsArea: React.FC<AccomodationsAreaProps> = () => {

  /* Hooks */
  const { getLanguageVarValue } = useSession();

  return <div>
    <span className="tw-block tw-font-bold">{getLanguageVarValue("LANG_neobooking_my_accomodations")} (données en dur)</span>
  </div>;
};

AccomodationsArea.propTypes = {
  //
};

export default AccomodationsArea;
